import React from 'react';
import PropTypes from 'prop-types'; // eslint-disable-line import/no-extraneous-dependencies

import InfoIcon from './InfoIcon';
import FileIcon from './FileIcon';
import FileUploadIcon from './FileUploadIcon';
import ArrowIcon from './ArrowIcon';
import CloseIcon from './CloseIcon';
import CheckIcon from './CheckIcon';
import InterrogationIcon from './InterrogationIcon';
import SpinnerIcon from './SpinnerIcon';

const CustomIcon = ({ iconName }) => {
  switch (iconName) {
    case 'accordion-arrow-down':
      return <ArrowIcon />;
    case 'check':
      return <CheckIcon />;
    case 'close':
      return <CloseIcon />;
    case 'info':
      return <InfoIcon />;
    case 'interrogation':
      return <InterrogationIcon />;
    case 'file':
      return <FileIcon />;
    case 'file-upload':
      return <FileUploadIcon />;
    case 'spinner':
      return <SpinnerIcon />;
    default:
      return null;
  }
};

CustomIcon.propTypes = {
  iconName: PropTypes.string,
};

CustomIcon.defaultProps = {
  iconName: '',
};

export default CustomIcon;
